import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalUnread: 0,
  unreadByConversation: {},
  remoteStatus: null,
  remoteId: null,
  conversationId: null,
};

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    incrementUnread(state, action) {
      const conversationId = action.payload;

      state.unreadByConversation[conversationId] =
        (state.unreadByConversation[conversationId] || 0) + 1;

      state.totalUnread += 1;
    },

    resetUnreadByConversation(state, action) {
      const conversationId = action.payload;
      const count = state.unreadByConversation[conversationId] || 0;

      state.totalUnread = Math.max(0, state.totalUnread - count);
      delete state.unreadByConversation[conversationId];
    },

    resetAllUnread(state) {
      state.totalUnread = 0;
      state.unreadByConversation = {};
    },

    setRemoteStatus(state, action) {
      state.remoteStatus = action.payload;
    },

    setRemoteId(state, action) {
      state.remoteId = action.payload;
    },

    setConversationId(state, action) {
      state.conversationId = action.payload;
    },
  },
});

export const {
  incrementUnread,
  resetUnreadByConversation,
  resetAllUnread,
  setConversationId,
  setRemoteStatus,
  setRemoteId,
} = messageSlice.actions;

export default messageSlice.reducer;